<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import axios from 'axios'

export default {
  page: {
    title: '360MDR Security Advisories',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data () {
    return {
      updated: '',
      advisories: [],
      title: 'Security Advisories',
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'Security Advisories',
          active: true
        }
      ],
      // Column headers for the table
      columns: [
        {
          key: 'vulnerable',
          label: 'Vulnerable'
        },
        {
          key: 'information',
          label: 'Information'
        },
        {
          key: 'reference',
          label: 'Reference'
        },
        {
          key: 'url',
          label: 'URL'
        },
        {
          key: 'datetime',
          label: 'Date'
        }
      ],
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      loading: true
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      let that = this
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const url = `${baseURL}/auto/advisories`
      
      that.loading = true
      
      axios.get(url)
        .then((response) => {
          that.advisories = response.data
          const now = new Date()
          that.updated = now.toLocaleString()
          that.loading = false
        })
        .catch(function() {
          that.loading = false
        })
    },
    // Format the date from the datetime object
    formatDate(datetimeObj) {
      if (!datetimeObj || !datetimeObj.$date) return 'N/A'
      
      const date = new Date(datetimeObj.$date)
      return date.toLocaleString()
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div
      class="container"
      style="max-width: 1420px !important;"
    >
      <div class="row page-title align-items-center" />
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h4 class="header-title">Security Advisories</h4>
              <span>Updated: {{ updated }}</span>
            </div>
            
            <!-- Loading spinner -->
            <div v-if="loading" class="text-center py-5">
              <!-- <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div> -->
              <p class="mt-2">Loading advisories...</p>
            </div>
            
            <!-- Table content (only shown when not loading) -->
            <div v-else class="table-responsive">
              <table class="table table-centered table-hover mb-0">
                <thead>
                  <tr>
                    <th v-for="column in columns" :key="column.key">{{ column.label }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(advisory, index) in advisories" :key="index">
                    <td>
                      <span 
                        :class="advisory.vulnerable && advisory.vulnerable.toLowerCase() === 'yes' ? 
                          'badge bg-danger' : 'badge bg-success'"
                      >
                        {{ advisory.vulnerable }}
                      </span>
                    </td>
                    <td>{{ advisory.information }}</td>
                    <td>{{ advisory.reference }}</td>
                    <td>
                      <a :href="advisory.url" target="_blank" rel="noopener noreferrer">
                        {{ advisory.url }}
                      </a>
                    </td>
                    <td>{{ formatDate(advisory.datetime) }}</td>
                  </tr>
                  <tr v-if="advisories.length === 0">
                    <td colspan="5" class="text-center">No advisories found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.table th {
  font-weight: 600;
}
.table td {
  vertical-align: middle;
}
</style>
